import { render, staticRenderFns } from "./Menu.vue?vue&type=template&id=385cbfcf&scoped=true"
import script from "./Menu.vue?vue&type=script&lang=js"
export * from "./Menu.vue?vue&type=script&lang=js"
import style0 from "./Menu.vue?vue&type=style&index=0&id=385cbfcf&prod&lang=css"
import style1 from "./Menu.vue?vue&type=style&index=1&id=385cbfcf&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385cbfcf",
  null
  
)

export default component.exports